var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-icon',{staticClass:"main-menu-mobile",attrs:{"icon":"fas fa-bars"},on:{"click":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }